export enum Rotas {
  LOGIN = "/login",
  VISAO_GERAL = "/visao-geral",
  GESTAO_DE_COBRANCAS = "/gestao-cobrancas",
  GESTAO_COBRANCAS_CADASTRO = "/gestao-cobrancas/gestao-cobrancas-cadastro",
  PROCESSOS_JUDICIAIS = "/gestao-cobrancas/processos-judiciais",
  CONTA_DIGITAL = "contas/conta-digital",
  GROUP_PAY = "/group-pay",
  GROUP_PAY_PROPOSTA_COMERCIAL = "/group-pay/proposta-comercial",
  GROUP_PAY_ATIVACAO_CONCLUIDA = "/group-pay/ativacao-concluida",
  GROUP_PAY_ = "/group-pay/ativacao-concluida",
  GROUP_PAY_CONFIGURAR = "/group-pay/configurar-group-pay",
  GROUP_PAY_LISTA_DESPESAS = "/group-pay/lista-despesas",
  GROUP_PAY_DETALHE_DESPESA = "/group-pay/detalhe-despesa",
  ASSINATURA_DIGIAL_CONFIGURACAO = "/assinatura-digital/configuracao",
  ASSINATURA_DIGITAL_CONFIGURACAO_CONDOMINIO = "/assinatura-digital/configuracao/condominio",
  ASSINATURA_DIGITAL_CONFIGURACAO_DOCUMENTO = "/assinatura-digital/configuracao/documento",
  ASSINATURA_DIGITAL_GESTAO = "/assinatura-digital/gestao",
  ASSINATURA_DIGITAL_PROPOSTA_COMERCIAL = "/assinatura-digital/proposta-comercial",
  ASSINATURA_ATIVACAO_CONCLUIDA = "/assinatura-digital/ativacao-concluida",
}

const rotaFinal = (rota: Rotas) => {
  const split = rota.split("/");
  return "/" + split[split.length - 1];
};

export const getNomeByRota = (rota: Rotas) => {
  switch (rota) {
    case Rotas.LOGIN:
      return "Login";
    case Rotas.VISAO_GERAL:
      return "Visão Geral";
    case Rotas.GESTAO_DE_COBRANCAS:
      return "Gestão de cobranças";
    case rotaFinal(Rotas.PROCESSOS_JUDICIAIS):
      return "Processos judiciais";
    case rotaFinal(Rotas.GESTAO_COBRANCAS_CADASTRO):
      return "Gestão de cobranças";
    case Rotas.GROUP_PAY:
      return "Group Pay";
    case rotaFinal(Rotas.CONTA_DIGITAL):
      return "Contas";
    case rotaFinal(Rotas.ASSINATURA_DIGIAL_CONFIGURACAO):
      return "Configurar assinaturas";
  }
};
